var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer-price-section tw-bg-white"},[_c('offer-pricing-section',{attrs:{"offer":_vm.offer}}),_c('offer-proposal-section',{attrs:{"offer":_vm.offer,"proposal":_vm.proposal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }